export const ERROR_MULTI_TIME = "error_multi_time";
export const CAPTCHA_INVALID = "captcha_invalid";
export const CAPTCHA_ERROR_EMPTY = "captcha_error_empty";
export const LOGIN_FAIL_MULTI = "login_fail_multi";
export const ACCOUNT_IS_LOCKED = "account_is_locked";
export const LOGIN_VALID_INFO = "login_invalid_info";
